
import { Component, Vue } from 'vue-property-decorator'
import lsPagination from "@/components/ls-pagination.vue";
import LsDialog from "@/components/ls-dialog.vue";
import { RequestPaging } from '@/utils/util'
import { apiTagDel, apiTagGroupEdit, apiTagGroupList } from '@/api/operating/group_welfare/tag'
@Component({
  components: {
    lsPagination,
    LsDialog
  }
})
export default class LabelGroup extends Vue {
  /** S Data*/
  pager: RequestPaging = new RequestPaging();
  active = 'all'
  query:any = {
    name: '',
  }
  form:any = {
    sort: 0
  }
  rules = {
    name: [
      {required: true, message: '请输入分组名称', trigger: 'blur'}
    ]
  }
  dialogShow = false
  /** E Data*/
  
  /** S Methods*/
  getList(page?: number) {
    page && (this.pager.page = page);
    this.pager.request({
      callback: apiTagGroupList,
      params: {
        ...this.query,
      },
    });
  }
  edit(row:any) {
    this.form = {
      id: row.id,
      name: row.name,
      sort: row.sort
    }
    this.dialogShow = true
  }
  add() {
    this.form = {
      sort: 0
    }
    this.dialogShow = true
  }
  submit() {
    const refs = this.$refs['form'] as HTMLFormElement
    refs.validate((valid: boolean): any => {
      if (!valid) return
      apiTagGroupEdit(this.form).then(res => {
        this.getList(1);
        this.dialogShow = false
      })
    })
  }
  del(row:any) {
    apiTagDel({id: row.id}).then(res => {
      this.getList(1)
    })
  }
  /** E Methods*/
  /** S ods **/
  created() {
    this.getList();
  }
}
